module.exports = __webpack_public_path__ + "img/img33.78767d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img33.jpg
// module id = 331
// module chunks = 0